import { GET_CURRENT_USER, GET_USER_MANAGER, IS_LOGGED } from '../actions/types';
import { PermissionRole } from "../GlobalConst/globalEnums";

const initialState = {
  isLogged: undefined,
  currentUser: undefined,
  manager: undefined,
  role: null,
  isAdmin: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case IS_LOGGED:
        var role = action.loggingInfo.id ? action.loggingInfo.role : null;
        var isAdmin = role &&
          [PermissionRole.administrator, 
          PermissionRole.contributor, 
          PermissionRole.reader,
          PermissionRole.owner].indexOf(role) > -1;
        var isLogged = action.loggingInfo === true || action.loggingInfo.id ? true : false;
        var currentUser = isLogged ? action.loggingInfo : null;
      return {
        ...state,
        isLogged,
        role,
        isAdmin,
        currentUser
      };
    case GET_CURRENT_USER:
        role = action.user.id ? action.user.role : null;
        isAdmin = role &&
          [PermissionRole.administrator, 
          PermissionRole.contributor, 
          PermissionRole.reader,
          PermissionRole.owner].indexOf(role) > -1;
        isLogged = action.user.id ? true : false;
        currentUser = isLogged ? action.user : null;
      return {
        ...state,
        isLogged,
        role,
        isAdmin,
        currentUser
      };
    case GET_USER_MANAGER:
      return {
        ...state,
        manager: action.manager
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/userReducer.js